<script lang="ts">
    import {Flex} from 'shared/layouts';
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import {createPayloadActionResponse} from 'src/modals/modal-utils';
    import {ignoreUnusedProperties} from 'shared/utils/custom-utils';
    import KpModalHeaderCloseButton from 'src/modals/kp-modal/KpModalHeaderCloseButton.svelte';
    import KpModalContent from 'src/modals/kp-modal/KpModalContent.svelte';
    import KpModalTitle from 'src/modals/kp-modal/KpModalTitle.svelte';
    import KpModalFooterCloseButton from 'src/modals/kp-modal/KpModalFooterCloseButton.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';

    export let model: void;
    ignoreUnusedProperties(model); // We don't need it
    export let modalWindowActions: ModalWindowActions;

    let divideExportsByDate = true;
    let replaceExisting = false;

    const handleExportClick = () => {
        modalWindowActions.resolve(Promise.resolve(createPayloadActionResponse({
            divideExportsByDate,
            replaceExisting
        })));
    };
</script>

<KpModalContent {modalWindowActions} additionalClasses="sutor-logbook-pairing-batch-export-modal">
    <svelte:fragment slot="header">
        <KpModalTitle>
            Hromadný export montážních deníků do souborů zakázky
        </KpModalTitle>

        <KpModalHeaderCloseButton/>
    </svelte:fragment>

    <svelte:fragment slot="body">
        <LabeledValue withoutBiggerValueText label="Rozřadit exporty do složek dle MD">
            <KpValueEditor type="boolean" bind:model={divideExportsByDate}/>
        </LabeledValue>

        <Flex direction="column" gap="s">
            <LabeledValue withoutBiggerValueText label="Přepsat existující soubory">
                <KpValueEditor type="boolean" bind:model={replaceExisting}/>
            </LabeledValue>

            <small class="text-muted">
                Pokud nevyberete přepsání, soubory se vytvoří automaticky s předponou (2), (3), atd.
            </small>

            {#if replaceExisting}
                <span class="text-danger">
                    Vaše staré exporty montážních deníků se stejným názvem souboru se smažou
                </span>
            {/if}
        </Flex>
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpButton buttonStyle="brand-orange" on:click={handleExportClick}>
            Exportovat
        </KpButton>

        <KpModalFooterCloseButton/>
    </svelte:fragment>
</KpModalContent>